/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect, useCallback, useRef } from 'react';
import './Header.css';
import { ReactComponent as Icon } from '../../assets/images/menuIcon.svg';

function Header() {
  const [activeSection, setActiveSection] = useState('glavnaya');
  const isScrollingToSection = useRef(false);
  const menuRef = useRef(null);

  const scrollToSection = useCallback((sectionId) => {
    setActiveSection(sectionId);
    isScrollingToSection.current = true;
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 60,
        behavior: 'smooth',
      });
    }
  }, []);

  useEffect(() => {
    const sections = ['glavnaya', 'uslugi', 'o-nas', 'faq', 'kontakty'];
    const handleScroll = () => {
      if (isScrollingToSection.current) return;
      const scrollY = window.scrollY + 130;
      let newActive = null;
      for (let sectionId of sections) {
        const section = document.getElementById(sectionId);
        if (!section) continue;
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        if (scrollY >= sectionTop - 50 && scrollY < sectionTop + sectionHeight - 50) {
          newActive = sectionId;
          break;
        }
      }
      if (newActive) setActiveSection(newActive);
    };
    const handleScrollEnd = () => { isScrollingToSection.current = false; };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('scrollend', handleScrollEnd);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scrollend', handleScrollEnd);
    };
  }, []);

  const menuItems = [
    { id: 'glavnaya', label: 'Главная' },
    { id: 'uslugi', label: 'Услуги' },
    { id: 'o-nas', label: 'О нас' },
    { id: 'faq', label: 'Вопросы' },
    { id: 'kontakty', label: 'Контакты' },
  ];

  const [isOpen, setOpen] = useState(false);

  // Исправленный обработчик клика вне меню
  useEffect(() => {
    if (!isOpen) return; // Только если меню открыто

    const handleClickOutside = (event) => {
      // Проверяем, был ли клик по кнопке меню
      if (event.target.closest('.header_menu-button')) {
        return; // Не закрываем меню, если клик был по кнопке
      }

      // Закрываем меню, только если клик вне контейнера меню
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isOpen]); // Зависимость — isOpen

  return (
    <header>
      <div className="Menu">
        <div className="MenuContent">
          <a
            href="#"
            className="Logo"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('glavnaya');
              setOpen(false); // Закрываем меню при клике на логотип
            }}
          >
            ООО "Характер металла"
          </a>
          <div
            className={`MenuLinks ${isOpen ? 'active' : ''}`}
            ref={menuRef}
          >
            {menuItems.map((item) => (
              <a
                key={item.id}
                className={`menu-link ${activeSection === item.id ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(item.id);
                  setOpen(false); // Закрываем меню после выбора пункта
                }}
              >
                {item.label}
              </a>
            ))}
          </div>
          <button
            className='header_menu-button'
            onClick={() => setOpen(!isOpen)}
          >
            <Icon/>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
